import { Injectable } from '@angular/core';
import {BehaviorSubject, Subject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {
  private spinnerSubject = new BehaviorSubject<boolean>(false);
  spinner$ = this.spinnerSubject.asObservable();

  show() {
    setTimeout(() => this.spinnerSubject.next(true), 0); // Defer the update
  }

  hide() {
    setTimeout(() => this.spinnerSubject.next(false), 0); // Defer the update
  }
}
